import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

export interface GetUserByIdInput {
  uid: string;
}

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetUserByIdUseCase({ userRepository }: Dependencies) {
  return async function getUserById(
    input: GetUserByIdInput,
  ): Promise<UserEntity | null> {
    return userRepository.getById(input.uid);
  };
}

